import React from 'react';
import '@/App.css';
import { Toaster } from 'sonner';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { ExportDivision } from './components/ExportDivision';
import { ChemicalDivision } from './components/ChemicalDivision';
import { FinancialServices } from './components/FinancialServices';
import { ExportConsultancy } from './components/ExportConsultancy';
import { AboutUs } from './components/AboutUs';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';

function App() {
  return (
    <div className="App noise-overlay">
      <Navbar />
      <Hero />
      <ExportDivision />
      <ChemicalDivision />
      <FinancialServices />
      <ExportConsultancy />
      <AboutUs />
      <Contact />
      <Footer />
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: '#0F1638',
            color: '#ffffff',
            border: '1px solid rgba(212, 175, 55, 0.3)',
          },
          className: 'glass-panel',
          success: {
            iconTheme: {
              primary: '#D4AF37',
              secondary: '#020420',
            },
          },
          error: {
            iconTheme: {
              primary: '#ef4444',
              secondary: '#020420',
            },
          },
        }}
      />
    </div>
  );
}

export default App;
